module.exports = __webpack_public_path__ + "img/img1.6420b14d.png";